/**
 * GPU resource disposal utilities.
 * Three.js GC does NOT free GPU memory — explicit .dispose() is required.
 */

import * as THREE from 'three/webgpu';

export function disposeTexture(texture: THREE.Texture): void {
  // ImageBitmap needs .close() before disposal
  if (typeof ImageBitmap !== 'undefined' && texture.image instanceof ImageBitmap) {
    texture.image.close();
  }
  texture.dispose();
}

export function disposeMaterial(material: THREE.Material): void {
  // Dispose all textures on the material
  const mat = material as unknown as Record<string, unknown>;
  for (const key of Object.keys(mat)) {
    const value = mat[key];
    if (value instanceof THREE.Texture) {
      disposeTexture(value);
    }
  }
  material.dispose();
}

export function disposeGeometry(geometry: THREE.BufferGeometry): void {
  geometry.dispose();
}

export function disposeRenderTarget(target: THREE.RenderTarget): void {
  target.dispose();
}

export function disposeObject3D(obj: THREE.Object3D): void {
  obj.traverse((child) => {
    // Duck-type: dispose geometry and material on any renderable
    // (Mesh, SkinnedMesh, Line, LineSegments, Points, Sprite, etc.)
    const c = child as unknown as Record<string, unknown>;

    if (c.geometry instanceof THREE.BufferGeometry) {
      disposeGeometry(c.geometry);
    }

    const mat = c.material;
    if (Array.isArray(mat)) {
      (mat as THREE.Material[]).forEach(disposeMaterial);
    } else if (mat instanceof THREE.Material) {
      disposeMaterial(mat);
    }
  });
}
